import { leadingZeros } from "utils/numeric";

export interface DateTimeFormat {
  shortDateFormat: string;
  shortDateTimeFormat: string;
  shortTimeFormat: string;
  regExDefinition: RegExp;
  convertToIso1806String: (value: string) => string;
}

const regEx: Record<string, RegExp> = {
  "en-GB": /^(?<day>0[1-9]|[12]\d|3[01])(?:-|\/)(?<month>0[1-9]|1[0-2])(?:-|\/)(?<year>[12]\d{3})$/,
  "en-US": /^(?<month>0[1-9]|1[0-2])(?:-|\/)(?<day>0[1-9]|[12]\d|3[01])(?:-|\/)(?<year>[12]\d{3})$/,
  "en-CA": /^(?<year>[12]\d{3})(?:-|\/)(?<month>0[1-9]|1[0-2])(?:-|\/)(?<day>0[1-9]|[12]\d|3[01])$/,

};

function convertToIso1806String(value: string, locale: string): string {
  const regex = regEx[locale];
  const match = regex ? value.match(regex) : null;
  return match?.groups
    ? `${match.groups["year"]}-${match.groups["month"]}-${match.groups["day"]}`
    : "";
}

export function dateTimeFormat(locale: string = "en-GB"): DateTimeFormat {
  const formatStrings: Record<string, DateTimeFormat> = {
    "en-GB": {
      shortDateFormat: "DD/MM/YYYY",
      shortDateTimeFormat: "DD/MM/YYYY, HH:mm",
      shortTimeFormat: "HH: mm",
      regExDefinition: regEx["en-GB"],
      convertToIso1806String: (value: string) =>
        convertToIso1806String(value, "en-GB"),
    },
    "en-US": {
      shortDateFormat: "MM/DD/YYYY",
      shortDateTimeFormat: "MM/DD/YYYY, HH:mm",
      shortTimeFormat: "HH: mm",
      regExDefinition: regEx["en-US"],
      convertToIso1806String: (value: string) =>
        convertToIso1806String(value, "en-US"),
    },
    "en-CA": {
      shortDateFormat: "YYYY/MM/DD",
      shortDateTimeFormat: "YYYY/MM/DD, HH:mm",
      shortTimeFormat: "HH: mm",
      regExDefinition: regEx["en-CA"],
      convertToIso1806String: (value: string) =>
        convertToIso1806String(value, "en-CA"),
    },
  };

  return formatStrings[locale] || formatStrings["en-GB"];
}

export function toNaiveDateString(date: Date) {
  return `${date.getFullYear()}-${leadingZeros(
    date.getMonth() + 1,
    2
  )}-${leadingZeros(date.getDate(), 2)}T${leadingZeros(
    date.getHours(),
    2
  )}:${leadingZeros(date.getMinutes(), 2)}:${leadingZeros(
    date.getSeconds(),
    2
  )}.000`;
}
